import { SubaccountMembership } from "src/components/SubaccountProvider";
import { Role } from "src/graphql/generated/globalTypes";

const roleDetails: {
  [key in Role]: { level: number; label: string };
} = {
  [Role.TENANT_OWNER]: { level: 0, label: "Organization Owner" },
  [Role.OWNER]: { level: 1, label: "Owner" },
  [Role.ADMIN]: { level: 2, label: "Admin" }
};

export function hasRole(membership: { role: Role }, role: Role): boolean {
  return roleDetails[membership.role].level <= roleDetails[role].level;
}

export function hasGreaterRole(
  membership: SubaccountMembership,
  role: Role
): boolean {
  return roleDetails[membership.role].level < roleDetails[role].level;
}

export function roleLabel(roleOrMembership: { role: Role } | Role): string {
  return roleDetails[
    typeof roleOrMembership === "string"
      ? roleOrMembership
      : roleOrMembership.role
  ].label;
}

export function equalAndLesserRoles(membership: { role: Role }): Role[] {
  return Object.keys(roleDetails)
    .filter(role => hasRole(membership, role as Role))
    .map(role => role as Role)
    .sort((a, b) => roleDetails[a].level - roleDetails[b].level);
}
